import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';
import { AppState } from '../store';
import { errorToastAction } from '../store/actions/toast.actions';
import { AuthService } from '../services/auth.service';
import { APIConstant } from '../constants/APIConstants';

// Every POST/PUT/PATCH/DELETE in the app is a write, apart from these
const allowedWrites = [
  APIConstant.auth.login,
  APIConstant.auth.newLogin,
  APIConstant.auth.changePassword,
  APIConstant.auth.sendPasswordResetEmail,
  APIConstant.auth.resetPassword,
];

// Safety net for view-only roles (SuperAdminViewOnly): action buttons are
// hidden in the UI, and any write that still gets through is stopped here
export const viewOnlyInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (
    !authService.isViewOnly() ||
    ['GET', 'HEAD', 'OPTIONS'].includes(req.method) ||
    allowedWrites.some((path) => req.url.split('?')[0].endsWith(path))
  ) {
    return next(req);
  }

  inject(Store<AppState>).dispatch(
    errorToastAction({
      autohide: true,
      delay: 5000,
      placement: 'top-end',
      message: 'You have view-only access and cannot perform this action',
    }),
  );

  return throwError(
    () =>
      new HttpErrorResponse({
        status: 403,
        statusText: 'Forbidden',
        url: req.url,
        error: { message: 'View-only access' },
      }),
  );
};
